import { EventParams, logEvent, setUserId } from 'firebase/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import firebaseStore from '../stores/firebaseStore';

export const usePageViewTracking = () => {
    const location = useLocation();

    useEffect(() => {
        if (firebaseStore.firebaseAnalytics) {
            logEvent(firebaseStore.firebaseAnalytics, 'page_view', {
                page_path: location.pathname,
            });
        }
    }, [location]);

    // 로그인 상태에 따라 사용자 아이디 설정
    useEffect(() => {
        if (!firebaseStore.firebaseAnalytics) {
            return;
        }

        if (firebaseStore.me) {
            setUserId(firebaseStore.firebaseAnalytics, firebaseStore.me.hash);
        } else {
            setUserId(firebaseStore.firebaseAnalytics, null);
        }
    }, [firebaseStore.me]);
};

/**
 * 클릭 로그를 남긴다
 * @param eventName 이벤트 이름
 * @param options 추가 옵션 (소문자 스케이크 케이스로 정의)
 */
export const logClientEvent = (eventName: string, options: EventParams) => {
    if (firebaseStore.firebaseAnalytics) {
        logEvent(firebaseStore.firebaseAnalytics, eventName, {
            ...options,
        });
    }
};
